import { PropsWithChildren } from "react";

import {
    SiteSelectorContextProvider,
    SiteSelectorContextProviderProps
} from "@/components/site-selector-modal/site-selector-context";

export interface OptionalSiteSelectorContextProviderProps
    extends PropsWithChildren {
    siteSelectorProductKey?: string;
    siteSelectorAnalyticsPrefix?: string;
}

export const OptionalSiteSelectorContextProvider = (
    props: OptionalSiteSelectorContextProviderProps
) => {
    const { siteSelectorProductKey, siteSelectorAnalyticsPrefix, children } =
        props;
    if (!siteSelectorProductKey) {
        return <>{children}</>;
    }

    return (
        <SiteSelectorContextProvider
            productKey={
                siteSelectorProductKey as SiteSelectorContextProviderProps["productKey"]
            }
            analyticsPrefix={
                siteSelectorAnalyticsPrefix ?? siteSelectorProductKey
            }
            internalLinkAfterIdentity={
                siteSelectorProductKey === "confluence.ondemand"
                    ? "/team-playbook/plays/choose-your-site"
                    : undefined
            }
        >
            {children}
        </SiteSelectorContextProvider>
    );
};
